import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

let campaigns = [];

function EmptyDropDown({ emptyLabel }) {
	return (
		<div>
			<FormControl sx={{ m: 1, width: 300 }}>
				<InputLabel id="emptyLabel-label">{emptyLabel}</InputLabel>
				<Select
					labelId="emptyLabel-label"
					id="emptyLabel-checkbox"
					single="true"
					input={<OutlinedInput label={emptyLabel} />}
					MenuProps={MenuProps}
					value=""
				>
					<MenuItem key={emptyLabel} value={emptyLabel}></MenuItem>
				</Select>
			</FormControl>
		</div>
	);
}
export default EmptyDropDown;
